import { render } from "./DepartmentsTab.vue?vue&type=template&id=0cb2ae62"
import script from "./DepartmentsTab.vue?vue&type=script&lang=js"
export * from "./DepartmentsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__